import React from 'react';
import styled from 'styled-components';
import {
  CpBody03Secondary,
  CpHeading03Primary,
} from 'components/atoms/customer-portal/typography';
import { useGetBackground } from 'components/organisms/customer-portal/types/utils';
import { CpSectionWrapper } from '../../common';
import { CpImageGalleryVariantWidgetProps } from '../types';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: flex-start;
  overflow-y: hidden;
  gap: var(--cp-spacing-06);
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-03);

  @media (max-width: 480px) {
    gap: var(--cp-spacing-03);
  }
`;

const Title = styled(CpHeading03Primary)`
  margin-bottom: 0;
`;

const Description = styled(CpBody03Secondary)`
  margin-bottom: 0;
`;

const ImagesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: var(--cp-spacing-06);
  width: 100%;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    /* grid-gap: 0; */
  }
`;

const ImageWrapper = styled.div`
  img {
    width: 100%;
    height: 100%;
  }
`;

export const CpImageGalleryGrid: React.FC<CpImageGalleryVariantWidgetProps> = ({
  disabled,
  data,
  widget,
}) => {
  const background = useGetBackground(widget);

  return (
    <CpSectionWrapper
      paddingY={widget?.widgetDefinition?.styles?.paddingY as number}
      isDisabled={disabled}
      background={background}
    >
      <Wrapper>
        <TitleWrapper>
          <Title autoAdjustColor>{data?.title}</Title>
          <Description autoAdjustColor>{data?.description}</Description>
        </TitleWrapper>
        <ImagesGrid>
          {(data?.images ?? []).map((image, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <ImageWrapper key={index} className="imageWrapper">
              <img
                src={image.attachment.location}
                alt={image.attachment.name}
              />
            </ImageWrapper>
          ))}
        </ImagesGrid>
      </Wrapper>
    </CpSectionWrapper>
  );
};
